/**
 * Route names defined for routes that only organizer user type can access.
 */
export const sportOrganizerRouteNames = {
  eventDashboardSport: 'sport-event-dashboard',
  sportFloorPlanOverview: 'sport-floor-plan-overview',
  visitorStatisticsSport: 'visitor-statistics-sport',
  scannedTicketsSport: 'scanned-tickets-sport',
  accreditationsSport: 'accreditations-sport',
  createAccreditationSport: 'create-accreditation-sport',
  editAccreditationSport: 'edit-accreditation-sport',
  importExportSport: 'import-export-sport',
  importSport: 'import-sport',
  exportSport: 'export-sport',
  emailsSport: 'emails-sport',
  createEmailSport: 'create-email-sport',
  emailDetailsSport: 'email-details-sport',
  updateEmailSport: 'update-email-sport',
  inviteAttendeeSport: 'invite-attendee-sport',
  requestsSport: 'requests-sport',
  editInviteSport: 'edit-invite-sport',
  membershipRequestSport: 'membership-request-sport',
  ticketsSport: 'tickets-sport',
  createTicketSport: 'create-ticket-sport',
  createGratisTicketSport: 'create-gratis-ticket-sport',
  gratisTicketsSport: 'gratis-tickets-sport',
  editTicketSport: 'edit-ticket-sport',
  floorPlanSport: 'floor-plan-sport',
  eventInfoSport: 'event-info-sport',
  eventCategoriesSport: 'event-categories-sport',
  attendeeFieldsSport: 'attendee-fields-sport',
  eventsSport: 'events-sport',
  organizationsSport: 'organizations-sport',
  createOrganizationSport: 'create-organization-sport',
  inviteSport: 'invite-sport',
  createTrialAccountSport: 'create-trial-account-sport',
  successfulPaymentSport: 'successful-payment-sport',
  customSuccessfulPaymentSport: 'custom-successful-payment-sport',
  addTicketSport: 'add-ticket-sport',
  scanEntriesSport: 'scan-entries-sport',
  sportEventWorkshops: 'sport-event-workshops',
  newWorkshopSport: 'new-workshop-sport',
  updateWorkshopSport: 'update-workshop-sport',
  storeSuccessfulPaymentSport: 'store-successful-payment-sport',
  eventDocumentationSport: 'event-documentation-sport',
  designWebshopTicketSport: 'design-webshop-ticket-sport',
}

export const sportOrganizationRouteNames = {
  sportOrganizationWorkingEvents: 'sport-organization-working-events',
  sportOrganizationEvents: 'sport-organization-events',
  sportLiveEvents: 'sport-live-events',
  sportPastEvents: 'sport-past-events',
  sportOrganizationAddEvent: 'sport-organization-add-event',
  sportOrganizationProfileInfo: 'sport-organization-profile-info',
  sportOrganizationFinanceInfo: 'sport-organization-finance-info',
  sportOrganizationTicketCategories: 'sport-organization-ticket-categories',
  sportOrganizationSubscriptionsPlan: 'sport-organization-subscriptions',
  sportOrganizationSubscriptionsListOverview: 'sport-organization-subscriptions-list-overview',
  sportOrganizationSubscriptionsList: 'sport-organization-subscriptions-list',
  sportOrganizationSubscriptionCreate: 'sport-organization-subscription-create',
  sportOrganizationSubscriptionUpdate: 'sport-organization-subscription-update',
  sportOrganizationMemberships: 'sport-organization-memberships',
  sportOrganizationMembersList: 'sport-organization-members-list',
  sportOrganizationMembersCreate: 'sport-organization-members-create',
  sportOrganizationMembershipRequest: 'sport-organization-membership-request',
  sportOrganizationMembersUpdate: 'sport-organization-members-update',
  sportOrganizationSubscribers: 'sport-organization-subscribers',
  sportOrganizationMessages: 'sport-organization-messages',
  sportOrganizationPromoCodes: 'sport-organization-promo-codes',
  sportOrganizationPromoCodeInfo: 'sport-organization-promo-code-info',
  sportOrganizationReports: 'sport-organization-reports',
  sportOrganizationMailingList: 'sport-organization-mailing-list',
  sportOrganizationUsers: 'sport-organization-users',
  sportOrganizationSubscriptionsEmails: 'sport-organization-subscriptions-emails',
  sportOrganizationSubscriptionRequirements: 'sport=organization-subscription-requirements',
  sportOrganizationSubscriptionsImport: 'sport-organization-subscriptions-import',
  sportOrganizationCreateSubscriptionEmail: 'sport-organization-create-subscription-email',
  sportOrganizationSubscriptionStatistics: 'sport-organization-subscription-statistics',
  sportOrganizationMembershipsEmails: 'sport-organization-memberships-emails',
  sportOrganizationMembershipsEmailsNew: 'sport-organization-memberships-emails-new',
  sportOrganizationMembershipRequirements: 'sport-organization-membership-requirements',
  sportOrganizationMembershipsImport: 'sport-organization-memberships-import',
  sportOrganizationCreateMembershipEmail: 'sport-organization-create-membership-email',
  sportOrganizationMembershipStatistics: 'sport-organization-membership-statistics',
  sportOrganizationMembersListOverview: 'sport-organization-members-list-overview',
  sportOrganizationBundleOffers: 'sport-organization-bundle-offers',
  sportOrganizationTicketingDeals: 'sport-organization-ticketing-deals',
}
